import { MainList } from "@/classes/MainList";
import contractorsList, {
  ContractorsListParams
} from "@/getinfo-api/contractors";
import api from "@/getinfo-api";
import { ContractorNew as IContractorNew } from "@/api/models/contractor-new";
import { uniqBy } from "lodash";

export class ContractorsListClass extends MainList {
  params: ContractorsListParams = {
    limit: 30,
    offset: 0
  };

  constructor(params?: any, selectedValue?: string | undefined) {
    super();
    this.method = contractorsList;
    this.params = { ...this.params, ...params };
    this.baseParams = this.params;
    this.dataLabel = "items";
    if (selectedValue) {
      this.singleMethod = () =>
        api.ContractorApi.getContractorNew(selectedValue);
      this.single();
    }
    this.list();
  }

  get contractors(): Array<IContractorNew> {
    return this.listItems;
  }

  get physical(): Array<IContractorNew> {
    return this.listItems.filter(
      (el: IContractorNew) => el.type === "physical"
    );
  }

  get juridical(): Array<IContractorNew> {
    return this.listItems.filter(
      (el: IContractorNew) => el.type === "juridical"
    );
  }

  async search(value: string) {
    this.isLoading = true;
    this.listItems = [];

    if (this.params.type === "juridical") {
      try {
        const params: ContractorsListParams = {
          ...this.params,
          searchJuridical: value
        };
        const { data } = await contractorsList(params);
        if (data?.items?.length) {
          this.listItems = [...this.listItems, ...data.items];
          this.listCount = data.count;
        }
      } finally {
        this.isLoading = false;
      }
    } else if (this.params.type === "physical") {
      try {
        const params: ContractorsListParams = {
          ...this.params,
          searchPhysical: value
        };
        const { data } = await contractorsList(params);
        if (data?.items?.length) {
          this.listItems = [...this.listItems, ...data.items];
          this.listCount = data.count;
        }
      } finally {
        this.isLoading = false;
      }
    }

    this.listItems = uniqBy(this.listItems, "id");
  }
}
